# A REQUEST THE PAGE ABANDONED BY LEAVING IS NOT A FAILURE — card
# 6ab462918db3fa386364276e.
#
# WebKit ends every request the old document still has in flight when the page
# reloads or navigates away, and rejects each one. A caller with no `.catch` of
# its own turns that into an unhandled rejection, so someone on Safari who
# reloads mid-request files a crash for nothing — a lazy chunk's ChunkLoadError
# on a production bundle, the i18n registry's upsertBatch POST on a dev bundle,
# or WebKit's bare "Unhandled Promise Rejection: undefined". Chromium does not
# reject them at all.
#
# MEASURED ON WEBKIT (Playwright 1.49, 2026-09-25), a page with a fetch and an
# XHR in flight, reloaded:
#
#   beforeunload @307ms, xhr onerror @307, fetch rejects @308,
#   pagehide @315, unload @316
#
# The aborts land AFTER `beforeunload` and BEFORE `pagehide`. So `pagehide`
# alone is too late to know the page is leaving; it has to start at
# `beforeunload`. But `beforeunload` can be cancelled (a page that asks "leave
# this page?" and the person stays), so from there it is a short GRACE window,
# not a state: if the page is still alive when it runs out, it was not leaving.
# `pagehide` makes it definite and `pageshow` (the page came back, e.g. from the
# back-forward cache) clears it.
#
# BOTH HALVES ARE REQUIRED. A network-shaped error while the page is staying is
# a real failure — the person is offline — and still reports. A server answer
# while the page is leaving is a real outcome and is left alone too.

EXIT_GRACE_MS = 3000
leavingUntil = 0

# Idempotent per window; a no-op where there is no window (this module is
# shared with the server, which imports client_api for its types).
installPageExitWatch = (win = (if typeof window != 'undefined' then window else null)) ->
  return false unless typeof win?.addEventListener == 'function'
  return true if win.__pageExitWatch
  win.__pageExitWatch = true
  win.addEventListener 'beforeunload', (-> leavingUntil = Math.max(leavingUntil, Date.now() + EXIT_GRACE_MS)), true
  win.addEventListener 'pagehide', (-> leavingUntil = Infinity), true
  win.addEventListener 'pageshow', (-> leavingUntil = 0), true
  true

isPageLeaving = (at = Date.now()) -> at < leavingUntil

# How a request looks when the BROWSER ended it rather than the server: no
# response, and the engine's own wording. axios says "Network Error" /
# "Request aborted" (codes ERR_NETWORK / ERR_CANCELED); fetch says "Load
# failed" (WebKit), "Failed to fetch" (Chromium), "NetworkError when attempting
# to fetch resource." (Firefox); webpack names a lazy chunk it could not load
# ChunkLoadError. ECONNABORTED alone is NOT enough: axios also uses it for a
# timeout, and a timeout is a real failure.
ABANDONED_MESSAGE = ///
  ^(?:Network\ Error|Request\ aborted|Load\ failed|Failed\ to\ fetch|NetworkError\ when\ attempting\ to\ fetch\ resource\.)$
  | due\ to\ access\ control\ checks
  | ^Loading\ (?:CSS\ )?chunk\ \S+\ failed
///

isAbandonedRequestShape = (err) ->
  return false unless err?
  return true if err.name == 'ChunkLoadError'
  return false if err.response?
  return true if err.code in ['ERR_NETWORK', 'ERR_CANCELED']
  ABANDONED_MESSAGE.test String(err.message ? err)

isPageExitAbort = (err, at = Date.now()) ->
  isPageLeaving(at) and isAbandonedRequestShape(err)

# CommonJS like its siblings: client_api's probe loader and the pins require it.
module.exports = {
  installPageExitWatch, isPageLeaving, isAbandonedRequestShape, isPageExitAbort
  PAGE_EXIT_GRACE_MS: EXIT_GRACE_MS
}
